import { render, staticRenderFns } from "./DelegatesGradeList.vue?vue&type=template&id=38180746&scoped=true"
import script from "./DelegatesGradeList.vue?vue&type=script&lang=ts"
export * from "./DelegatesGradeList.vue?vue&type=script&lang=ts"
import style0 from "./DelegatesGradeList.vue?vue&type=style&index=0&id=38180746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38180746",
  null
  
)

export default component.exports